if($('.roll-call').length) {
    (function() {
        "use strict";

        var _get = function(d) {
            $(".roll-call").empty();
            $(".loader").show();
            $.ajax({
                url: "/ajax/attendance/get",
                method: 'post',
                data: {
                    s: $('#session-id').val(),
                    d: d
                }
            }).done(function(e) {
                $(".roll-call").append(e.html);
                $('.loader').hide();
            })
        };
        $('body').on("click", ".switch-attendance", function() {
            _get($(this).val());
        }).on("click", ".confirm-attendance", function () {
            $(".loader-small").show();
            $.ajax({
                url: "/ajax/attendance/confirm",
                method: 'post',
                data: $("#confirm-attendance-form").serialize()
            }).done(function (e) {
                $('.loader-small').hide();
                if (!e.success) {
                    $('.loader-success').html(e.error);
                } else {
                    $('.loader-success').html("Attendance saved!");
                }
                $('.loader-success').show().delay(2500).fadeOut();
            });

            return false;
        });

        var d = new Date();
        _get(d.getFullYear()+"-"+(d.getMonth() + 1)+"-"+d.getDate());
    })();
}